module.exports = __webpack_public_path__ + "static/riots-logo-18c00016c67a1f3605e68371c035a010.svg";